// Duck for ReportPickupIssuePage (renter flags a pickup issue in the 4h window).
import { storableError } from '../../util/errors';
import { postHandoffTransition } from '../../util/pickupCode';

const FETCH_TX_REQUEST = 'app/ReportPickupIssuePage/FETCH_TX_REQUEST';
const FETCH_TX_SUCCESS = 'app/ReportPickupIssuePage/FETCH_TX_SUCCESS';
const FETCH_TX_ERROR = 'app/ReportPickupIssuePage/FETCH_TX_ERROR';
const SUBMIT_REQUEST = 'app/ReportPickupIssuePage/SUBMIT_REQUEST';
const SUBMIT_SUCCESS = 'app/ReportPickupIssuePage/SUBMIT_SUCCESS';
const SUBMIT_ERROR = 'app/ReportPickupIssuePage/SUBMIT_ERROR';
const SUBMIT_RESET = 'app/ReportPickupIssuePage/SUBMIT_RESET';

const initialState = {
  transaction: null,
  fetchInProgress: false,
  fetchError: null,
  submitInProgress: false,
  submitError: null,
  submitSuccess: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_TX_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_TX_SUCCESS:
      return { ...state, fetchInProgress: false, transaction: action.payload };
    case FETCH_TX_ERROR:
      return { ...state, fetchInProgress: false, fetchError: action.payload };
    case SUBMIT_REQUEST:
      return { ...state, submitInProgress: true, submitError: null, submitSuccess: false };
    case SUBMIT_SUCCESS:
      return { ...state, submitInProgress: false, submitSuccess: true };
    case SUBMIT_ERROR:
      return { ...state, submitInProgress: false, submitError: action.payload };
    case SUBMIT_RESET:
      return { ...state, submitError: null, submitSuccess: false };
    default:
      return state;
  }
}

export const submitReset = () => ({ type: SUBMIT_RESET });

export const loadData = params => (dispatch, getState, sdk) => {
  dispatch({ type: FETCH_TX_REQUEST });
  return sdk.transactions
    .show({ id: params.id, include: ['customer', 'provider', 'listing', 'booking'] })
    .then(resp => {
      const tx = resp?.data?.data;
      const included = resp?.data?.included || [];
      const byRel = rel => included.find(e => e.id.uuid === rel?.id?.uuid);
      dispatch({
        type: FETCH_TX_SUCCESS,
        payload: {
          ...tx,
          customer: byRel(tx?.relationships?.customer?.data),
          provider: byRel(tx?.relationships?.provider?.data),
          listing: byRel(tx?.relationships?.listing?.data),
          booking: byRel(tx?.relationships?.booking?.data),
        },
      });
    })
    .catch(e => {
      dispatch({ type: FETCH_TX_ERROR, payload: storableError(e) });
      throw e;
    });
};

export const submitReportPickupIssue = ({ transactionId, description, photoKeys }) => dispatch => {
  dispatch({ type: SUBMIT_REQUEST });
  return postHandoffTransition({
    transactionId,
    transition: 'transition/report-pickup-issue',
    orderData: {
      issueDescription: description,
      issuePhotos: photoKeys || [],
    },
  })
    .then(r => {
      dispatch({ type: SUBMIT_SUCCESS });
      return r;
    })
    .catch(err => {
      dispatch({ type: SUBMIT_ERROR, payload: storableError(err) });
      throw err;
    });
};
